export const staticSubjectType =  {
  "wiki":"维基百科"
}